import { observer } from 'mobx-react-lite';
import { IAreaMeterAllReadings } from '../../../../../store/models/metersStore';
import {
  EmptyBlock,
  MetersTable,
  TableHeader,
  TableBody,
} from '../../meters.styled';
import { ListItem } from '../list-item';

interface Props {
  meters: IAreaMeterAllReadings[];
  collapsed: boolean;
  isArchive: boolean;
}

export const MetersList = observer(
  ({ meters, collapsed, isArchive }: Props) => {
    return meters.length > 0 ? (
      <MetersTable collapsed={collapsed}>
        <TableHeader>
          <tr>
            <th>Счётчики</th>
            <th>Последние показания</th>
            <th>Тариф</th>
            <th>Текущие показания</th>
            <th>Следующая поверка</th>
          </tr>
        </TableHeader>
        <TableBody>
          {meters.map((meter: IAreaMeterAllReadings) => (
            <ListItem key={meter.id} meter={meter} />
          ))}
        </TableBody>
      </MetersTable>
    ) : (
      <EmptyBlock collapsed={collapsed}>
        У данного жителя отсутствуют {isArchive ? 'архивные' : 'квартирные'}{' '}
        счётчики
      </EmptyBlock>
    );
  }
);
